import JavascriptDataType from "../../utils/stringLiterals/JavascriptDataType";

//TESTED
const isValidJson = function(input){
    if(typeof input !== JavascriptDataType.STRING){

        return false;
    }

    try{
        JSON.parse(input);
    }
    catch(error){

        return false;
    }

    return true;
}

//TESTED
const safeJsonParse = function (input) {
    let value = input;

    if (isValidJson(input)) {
        value = JSON.parse(input);
    }

    return value;
}


const JsonObjectInspector = Object.freeze({
    isValidJson:isValidJson,
    safeJsonParse : safeJsonParse
});

export default JsonObjectInspector;